/**
 * QA Hub Utilities
 * Re-exports shared functions from @quotech/ui — QA-specific helpers below.
 */
import { useState, useEffect } from 'react'

export { cn, formatDate, formatDateTime } from '@quotech/ui'

/**
 * Hook: detect mobile viewport.
 * WHY: Many QA actions happen on-site via phone.
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  )

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mql.addEventListener('change', handler)
    setIsMobile(mql.matches)
    return () => mql.removeEventListener('change', handler)
  }, [breakpoint])

  return isMobile
}

/** Minimum touch target size for WCAG 2.5.8 compliance (44x44px). */
export const TOUCH_TARGET = 'min-h-[44px] min-w-[44px]'
